import instance from '../axios';

export const getCountries = () => {
  return instance.get('/catalogs/country');
};

export const getMakers = () => {
  return instance.get('/catalogs/maker');
};
